namespace $.$$ {
	$mol_style_define($bog_mol_app, {
		Context: {
			Body_content: {
				gap: $mol_gap.block,
			},
		},
	})
}
